import { createFileRoute } from '@tanstack/react-router';

import { medplum } from '@/config/medplum';
import { queryClient } from '@/config/queryClient';
import { queryKeys } from '@/lib/query-keys';

export const Route = createFileRoute('/(authenticated)/assessments/$id')({
	beforeLoad: async ({ params }) => {
		const questionnaire = await queryClient.ensureQueryData({
			queryKey: queryKeys.questionnaire.detail(params.id),
			queryFn: () => medplum.readResource('Questionnaire', params.id),
		});

		return { questionnaire };
	},
});
